module.exports = __webpack_public_path__ + "static/banner-image-a5152d8aa40cbf015a0279b82356c343.png";